import { render, staticRenderFns } from "./OrderRowEdit.vue?vue&type=template&id=17881f36&scoped=true"
import script from "./OrderRowEdit.vue?vue&type=script&lang=js"
export * from "./OrderRowEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17881f36",
  null
  
)

export default component.exports